/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthSessionLogout$Params {
}

export function authSessionLogout(http: HttpClient, rootUrl: string, params?: AuthSessionLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Status of the logout operation
 */
'status'?: 'success' | 'error';

/**
 * Message providing additional information about the logout operation
 */
'message'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, authSessionLogout.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Status of the logout operation
       */
      'status'?: 'success' | 'error';
      
      /**
       * Message providing additional information about the logout operation
       */
      'message'?: string;
      }>;
    })
  );
}

authSessionLogout.PATH = '/auth/sessionLogout';
